/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Swarmind API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
/**
 * LocalAIProxyApi - axios parameter creator
 * @export
 */
export const LocalAIProxyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve a list of all available LocalAI federated heads
         * @summary heads
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNewAPIServiceFunc1: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/heads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocalAIProxyApi - functional programming interface
 * @export
 */
export const LocalAIProxyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocalAIProxyApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve a list of all available LocalAI federated heads
         * @summary heads
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNewAPIServiceFunc1(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNewAPIServiceFunc1(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LocalAIProxyApi.apiNewAPIServiceFunc1']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * LocalAIProxyApi - factory interface
 * @export
 */
export const LocalAIProxyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocalAIProxyApiFp(configuration)
    return {
        /**
         * Retrieve a list of all available LocalAI federated heads
         * @summary heads
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNewAPIServiceFunc1(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.apiNewAPIServiceFunc1(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocalAIProxyApi - interface
 * @export
 * @interface LocalAIProxyApi
 */
export interface LocalAIProxyApiInterface {
    /**
     * Retrieve a list of all available LocalAI federated heads
     * @summary heads
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocalAIProxyApiInterface
     */
    apiNewAPIServiceFunc1(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>>;

}

/**
 * LocalAIProxyApi - object-oriented interface
 * @export
 * @class LocalAIProxyApi
 * @extends {BaseAPI}
 */
export class LocalAIProxyApi extends BaseAPI implements LocalAIProxyApiInterface {
    /**
     * Retrieve a list of all available LocalAI federated heads
     * @summary heads
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocalAIProxyApi
     */
    public apiNewAPIServiceFunc1(options?: RawAxiosRequestConfig) {
        return LocalAIProxyApiFp(this.configuration).apiNewAPIServiceFunc1(options).then((request) => request(this.axios, this.basePath));
    }
}

